import React from 'react';
import {
  Dialog as DialogPrimitive,
  DialogContent as BaseDialogContent,
  DialogPortal,
  DialogOverlay,
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

// Create a custom DialogContent that doesn't include the default close button
const CustomDialogContent = React.forwardRef<
  React.ElementRef<typeof BaseDialogContent>,
  React.ComponentPropsWithoutRef<typeof BaseDialogContent>
>(({ className, children, ...props }, ref) => {
  return (
    <DialogPortal>
      <DialogOverlay />
      <BaseDialogContent
        ref={ref}
        className={cn(
          "fixed left-[50%] top-[50%] z-50 grid w-full h-full max-w-none max-h-none m-0 rounded-none translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] md:w-full md:max-w-lg md:h-auto md:max-h-[90vh] md:m-4 md:rounded-lg",
          className
        )}
        {...props}
        showCloseButton={false}
      >
        {children}
      </BaseDialogContent>
    </DialogPortal>
  );
});

CustomDialogContent.displayName = "CustomDialogContent";

export default CustomDialogContent;
